window.addEventListener('load', () => {
	const underlinedHeadings = document.querySelectorAll('.is-style-underlined');
	underlinedHeadings.forEach((heading) => {
		if (heading.classList.contains('has-text-align-center')) {
			const wrapper = document.createElement('div');
			wrapper.classList.add('has-text-align-center-wrapper');
			heading.parentNode.insertBefore(wrapper, heading);
			wrapper.appendChild(heading);
		}
	});
});
